import React, { lazy } from 'react';
import { SectionHeader } from './SectionHeader';
const pillColors = ['#FFCBA4', '#FFB5A7', '#FFF0A0', '#D8CCFF', '#B8E0FF', '#C8F0C8' // verde pálido
];
const badges = ['+160 pág.', 'Técnicas reales', 'Gestión del estrés', 'Memoria', 'Concentración', 'Día del examen', 'Manejo del pánico', 'Recuperatorio', 'Planificación', 'Hábitos'];
const pills = ['Aprobar bajo presión', 'Estudiar con método', 'Dormir antes del examen', 'No bloquearse', 'Manejar la ansiedad', 'Organizar el tiempo', 'Retener más en menos tiempo', 'Levantarse después de reprobar', 'Concentrarse sin distracciones', 'Rendir el día del examen'];
export function TheSystem() {
  return <section className="py-20 px-6 lg:px-8 bg-white" data-id="element-230">
      <div className="max-w-[1100px] mx-auto text-center" data-id="element-231">
        <SectionHeader data-id="element-232" />
        <h2 className="text-3xl md:text-4xl font-extrabold mb-4" data-id="element-233">
          EL SISTEMA N°1 EN ARGENTINA
        </h2>
        <p className="text-xl text-salmon font-bold mb-8" data-id="element-234">
          Aprobá en serio · digsol.shop
        </p>

        <p className="text-lg md:text-xl font-medium mb-10 max-w-2xl mx-auto" data-id="element-235">
          Sistema completo · 6 Tomos + 4 Bonos · Cualquier carrera · Todo
          resuelto.
        </p>

        <div className="flex justify-center mb-10" data-id="element-236">
          <img src="https://cdn.magicpatterns.com/uploads/uSKTb3WrqrPE4zzNLVUC3w/Diseno_sin_titulo_(1).png" alt="DigSol Logo" className="h-40 md:h-56 w-auto object-contain opacity-90 mt-[-25px] mb-[-25px]" loading="lazy" data-id="element-237" />
        </div>

        <div className="flex flex-wrap justify-center gap-2 mb-10 max-w-4xl mx-auto" data-id="element-238">
          {badges.map((badge, idx) => <span key={idx} className="bg-lavender/20 text-dark font-semibold px-4 py-1.5 rounded-full text-sm border border-lavender/30" data-id="element-239">
              {badge}
            </span>)}
        </div>

        <p className="text-xl font-bold mb-10 bg-peach/30 inline-block px-8 py-4 rounded-2xl" data-id="element-240">
          Funciona desde hoy, para cualquier materia y cualquier carrera.
        </p>

        <div className="flex flex-wrap justify-center gap-2 max-w-4xl mx-auto" data-id="element-241">
          {pills.map((pill, idx) => <span key={idx} style={{
          backgroundColor: pillColors[idx % pillColors.length]
        }} className="w-[calc(50%-4px)] md:w-auto text-center text-dark font-semibold rounded-full text-[11px] md:text-[13px] px-[10px] py-[6px] md:px-4 md:py-2" data-id="element-242">
              {pill}
            </span>)}
        </div>
      </div>
    </section>;
}